import { getPageUrls } from '@/project/content/api/contentApi';
import { setupDynamicRoutes } from '@/router';

export default async function config(): Promise<void> {
    return getPageUrls()
        .then(({
            giftCardCheckoutInformationUrl,
            giftCardCheckoutPaymentUrl,
            giftCardCheckoutReceiptUrl,
        }) => {
            setupDynamicRoutes({
                giftCardCheckoutInformationUrl,
                giftCardCheckoutPaymentUrl,
                giftCardCheckoutReceiptUrl,
            });
        });
}
